module.exports = __webpack_public_path__ + "static/media/hero-consultation.acb3a3b9.jpg";